import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@mui/material/IconButton'
import { close } from '../../assets/images/icons'

import { ModalWrapper, Overlay, Popup, CloseWrap, Title, Content } from './style'
import MuiButtons from '../muiButtons'
import { IconClose } from '../../assets/images/iconsV2'
import MuiButton from '../muiButton'

const Modal = ({
  children,
  title,
  showClose = false,
  onClose,
  modalClass = '',
  popupClass = '',
  styleType = '',
  titleClass = '',
  style = {}
}) => {
  const closeModal = () => {
    if (showClose) onClose()
  }
  return (
    <ModalWrapper className={`modalWrapper ${modalClass} ${styleType}`}>
      <Overlay onClick={closeModal} />
      <Popup className={`PopupWrapper ${popupClass}`}>
        {showClose && (
          <>
            {styleType === 'themeV2' ? (
              <CloseWrap className={'closeBtn'}>
                <MuiButton
                  variant='outlined'
                  color='light'
                  startIcon={<IconClose />}
                  onClick={closeModal}
                />
              </CloseWrap>
            ) : (
              <CloseWrap className={'closeBtn'} onClick={closeModal}>
                <IconButton color='secondary'>
                  <img src={close} alt='Close' width='24px' />
                </IconButton>
              </CloseWrap>
            )}
          </>
        )}

        {title && <Title className={`popupTitle ${titleClass ? titleClass : ''}`}>{title}</Title>}
        <Content className='popupContent'>{children}</Content>
      </Popup>
    </ModalWrapper>
  )
}

export default Modal
